export enum Salutation {
  HERR = 'HERR',
  FRAU = 'FRAU',
}

export const Salutations = [
  { value: 'HERR', label: 'Herr' },
  { value: 'FRAU', label: 'Frau' },
];
